export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";

export const loginSuccess = (payload) => ({
  type: LOGIN_SUCCESS,
  payload,
});

export const updateUser = (user) => ({
  type: UPDATE_USER,
  payload: user,
});

export const logout = () => {
  localStorage.removeItem("accessToken");

  return {
    type: LOGOUT,
  };
};